<template>
    <!--== Participants ==-->
    <article style="position: relative;">
        <v-overlay v-model="loading" contained class="align-center justify-center" scrim="transparent" persistent>
            <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <h1 class="text-center m-5">Attendees FOR {{ eventName.toUpperCase() }}</h1>

        <!-- Beneficiaries Participants Table -->
        <div class="table-responsive m-5 mb-0 table-participants-container" id="no-more-tables">
            <div class="d-flex justify-content-between mb-3 align-items-center table-title">
                <h2 class="pe-5">Participants</h2>
                <div class="rounded px-3 py-2 bg-lightblue">
                    <h3 class="fw-semibold fs-5">Count: {{ participants.length }}</h3>
                </div>
            </div>
            <table class="table table-hover text-center">
                <thead class="table-blue text-light text-uppercase">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Contact Number</th>
                    </tr>
                </thead>
                <tbody v-if="participants.length != 0">
                    <tr v-for="participant in participants" :key="participant.id">
                        <td>{{ participant.Name }}</td>
                        <td>{{ participant.Email }}</td>
                        <td>{{ participant.ContactNumber }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="3" class="text-center"> {{ loading ? "Loading..." : "No Beneficiaries" }} </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Volunteers Participants Table -->
        <div class="table-responsive m-5 mt-2 table-participants-container" id="no-more-tables">
            <div class="d-flex justify-content-between mb-3 align-items-center table-title">
                <h2 class="pe-5">VOLUNTEERS</h2>
                <div class="rounded px-3 py-2 bg-lightblue">
                    <h3 class="fw-semibold fs-5">Count: {{ volunteers.length }}</h3>
                </div>
            </div>
            <table class="table table-hover text-center">
                <thead class="table-blue text-light text-uppercase">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Contact Number</th>
                    </tr>
                </thead>
                <tbody v-if="volunteers.length != 0">
                    <tr v-for="volunteer in volunteers" :key="volunteer.id">
                        <td>{{ volunteer.Name }}</td>
                        <td>{{ volunteer.Email }}</td>
                        <td>{{ volunteer.ContactNumber }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="3" class="text-center"> {{ loading ? "Loading..." : "No Volunteers" }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router'
import { db } from "@/firebase";
import { collection, query, where, orderBy, getDoc, doc, onSnapshot } from "firebase/firestore";
import { onMounted } from 'vue';
import { onUnmounted } from 'vue';


export default {
    setup() {
        const route = useRoute()
        const eventId = computed(() => route.params.id).value

        const participants = ref([])
        const volunteers = ref([])
        let eventName = ref("")
        let unsubscribeEvents;
        let unsubscribeVolunteers;

        const isEventsLoading = ref(true);
        const isVolunteersLoading = ref(true);
        const loading = computed(() => isEventsLoading.value || isVolunteersLoading.value)

        onMounted(() => {

            // Get all participants and volunteers for the event
            const eventRegistrationsCollection = collection(db, "Event Registrations")
            const volunteersCollection = collection(db, "Volunteer Applications")
            const eventsQuery = query(eventRegistrationsCollection,
                where("EventRegisteredId", "==", eventId),
                where("IsArchived", "==", false),
                orderBy("CreationTimestamp", "asc"));
            const volunteersQuery = query(volunteersCollection,
                where("EventAppliedId", "==", eventId),
                where("IsAccepted", "==", true),
                where("IsArchived", "==", false),
                orderBy("CreationTimestamp", "asc"));

            unsubscribeEvents = onSnapshot(eventsQuery, (snapshot) => {
                participants.value = snapshot.docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                isEventsLoading.value = false; // Hide loading once data is fetched
            })

            unsubscribeVolunteers = onSnapshot(volunteersQuery, (snapshot) => {
                volunteers.value = snapshot.docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                isVolunteersLoading.value = false; // Hide loading once data is fetched
            })

            const getEventName = async () => {
                const docRef = doc(db, "Events", eventId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    eventName.value = docSnap.data().Name
                } 
            }

            getEventName()

        })

        onUnmounted(() => {
            unsubscribeEvents()
            unsubscribeVolunteers()
        })

        return { participants, volunteers, eventName, loading }
    }
}
</script>

<style scoped src="@/assets/css/admin.css"></style>